<script setup>
import { frames } from '../../../../utils/frames'
import CharacterEnlarge from '../text_animations/CharacterEnlarge.vue'
import TextSlideUp from '../text_animations/TextSlideUp.vue'
import ContentContainer from './../ContentContainer.vue'
import AnimatedSkewedEllipsMask from './AnimatedSkewedEllipsMask.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  title: String,
  subtitle: {
    type: String,
    default: null,
  },
  body: String,
  imageUrl: {
    type: String,
    default: null,
  },
  titleClass: {
    type: String,
    default: '',
  },
  subtitleClass: {
    type: String,
    default: '',
  },
})

const timelineSubtitle = ref(null)
const timelineTitle = ref(null)
const timelineImage = ref(null)

const bodyElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'ArticleFull' })
    .add(timelineTitle, frames(22))
    .from(bodyElement, { opacity: 0, y: 80, duration: frames(10) }, `<${frames(3)}`)
    .add(timelineSubtitle, `<${frames(4)}`)
    .add(timelineImage, `<${frames(1)}`)
})
</script>

<template>
  <ContentContainer class="pt-48 flex space-x-24 text-white">
    <div v-if="imageUrl" class="h-112 w-112">
      <AnimatedSkewedEllipsMask v-if="imageUrl" class="h-full w-full" @timeline="timelineImage = $event">
        <img :src="imageUrl" class="object-cover h-full w-full" />
      </AnimatedSkewedEllipsMask>
    </div>
    <div class="flex-1 space-y-8">
      <TextSlideUp v-if="subtitle" :text="subtitle" :class="['text-5xl', subtitleClass]" @timeline="timelineSubtitle = $event" />
      <CharacterEnlarge :text="title" class="font-bold text-7xl" :class="titleClass" @timeline="timelineTitle = $event" />
      <p ref="bodyElement" class="font-qarla normal-case text-5xl line-clamp-[11] leading-[1.1] whitespace-pre-wrap">
        <slot />
      </p>
    </div>
  </ContentContainer>
</template>
